import { ChatNavBarLastOnlineStatusBadge } from 'gcs-common/components/ChatNavBarLastOnlineStatusBadge/ChatNavBarLastOnlineStatusBadge';
import { RIGHT_BAR_TABS } from 'gcs-common/constants/uiFlags';
import { useSidebar } from 'gcs-common/design-system/ui/sidebar';
import { cn } from 'gcs-common/design-system/utils/tailwind-merge';
import {
  getChannelImage,
  getChannelMemberCount,
  getChannelStatus,
  getChannelSubtitle,
  getChannelTitle,
  getDirectChannelUserId,
  getIsHidden,
  getIsSalesSpaceChannelType,
} from 'gcs-common/slices/channel/channelSelectors';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { getIsAgent } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { currentUserIdSelected } from 'gcs-common/slices/memberDetails/memberDetailsSlice';
import { setRightBarTab } from 'gcs-common/slices/uiState/uiStateSlice';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ImageWithStatus from '../../ImageWithStatus/ImageWithStatus';
import styles from './styles.module.scss';

export function ChannelDetailsButton({ className }) {
  const dispatch = useDispatch();

  const selectedChannelId = useSelector(getSelectedChannelId);
  const isAgent = useSelector(getIsAgent);
  const channelMemberCount = useSelector(getChannelMemberCount(selectedChannelId));
  const channelTitle = useSelector(getChannelTitle(selectedChannelId));
  const channelSubtitle = useSelector(getChannelSubtitle(selectedChannelId));
  const channelStatus = useSelector(getChannelStatus(selectedChannelId));
  const channelImage = useSelector(getChannelImage(selectedChannelId));
  const isSalesSpaceChannel = useSelector(getIsSalesSpaceChannelType(selectedChannelId));
  const isHidden = useSelector(getIsHidden(selectedChannelId));
  const otherUserId = useSelector(getDirectChannelUserId(selectedChannelId));

  const sidebar = useSidebar();
  const onHeaderClicked = useCallback(() => {
    sidebar.setOpen(true);
    dispatch(setRightBarTab({ rightBarTab: RIGHT_BAR_TABS.CHANNEL_DETAILS }));
    dispatch(
      currentUserIdSelected({
        userId: otherUserId,
      }),
    );
  }, [dispatch, channelMemberCount, otherUserId, selectedChannelId, isSalesSpaceChannel, isAgent, sidebar]);

  return (
    <button
      className={cn('flex flex-row items-center gap-x-2 overflow-hidden', className)}
      type="button"
      onClick={onHeaderClicked}
    >
      <ImageWithStatus
        imageUrl={channelImage}
        userStatus={channelStatus}
        isSalesSpace={isSalesSpaceChannel}
        className="m-1"
        channelMemberCount={channelMemberCount}
        isAgent={isAgent}
      />
      <div className="flex flex-col justify-center overflow-hidden">
        <div className="truncate text-left font-medium text-base">{channelTitle}</div>
        <div className="flex min-h-6 flex-row items-center gap-1">
          {isHidden ? (
            <div className={styles.hiddenIndicator}>Archiviert</div>
          ) : (
            <ChatNavBarLastOnlineStatusBadge selectedChannelId={selectedChannelId} />
          )}
          <div className="truncate text-left text-neutral-11 text-sm">{channelSubtitle}</div>
        </div>
      </div>
    </button>
  );
}

ChannelDetailsButton.propTypes = {
  className: PropTypes.string,
};
